import type { Paths } from '@vs-shop/schemas/openapi/paths';
import { Context } from 'effect';

import { ContextTag } from '../context';
import type { OpenApiClient } from './OpenApiClient';

export class BackendApi extends Context.Service<BackendApi, OpenApiClient<Paths>>()(
  ContextTag.BackendApi
) {}
